import * as React from "react";
import { TransformGroup } from "./TransformGroup";

const Default = () => (
    <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.00002 2.39999C5.3314 2.39999 5.60002 2.66862 5.60002 2.99999V11.5515L7.57576 9.57573C7.81007 9.34141 8.18997 9.34141 8.42429 9.57573C8.6586 9.81004 8.6586 10.1899 8.42429 10.4243L5.42429 13.4243C5.18997 13.6586 4.81008 13.6586 4.57576 13.4243L1.57576 10.4243C1.34145 10.1899 1.34145 9.81004 1.57576 9.57573C1.81007 9.34141 2.18997 9.34141 2.42429 9.57573L4.40002 11.5515V2.99999C4.40002 2.66862 4.66865 2.39999 5.00002 2.39999ZM10.5758 2.57573C10.8101 2.34142 11.19 2.34142 11.4243 2.57573L14.4243 5.57573C14.6586 5.81004 14.6586 6.18994 14.4243 6.42426C14.19 6.65857 13.8101 6.65857 13.5758 6.42426L11.6 4.44852V13C11.6 13.3314 11.3314 13.6 11 13.6C10.6687 13.6 10.4 13.3314 10.4 13V4.44852L8.42429 6.42426C8.18997 6.65857 7.81007 6.65857 7.57576 6.42426C7.34145 6.18994 7.34145 5.81004 7.57576 5.57573L10.5758 2.57573Z"
    />
);

const Up = () => (
    <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.9999 13.6C8.33127 13.6 8.5999 13.3313 8.5999 13V4.4485L10.5756 6.42424C10.81 6.65855 11.1899 6.65855 11.4242 6.42424C11.6585 6.18993 11.6585 5.81003 11.4242 5.57571L8.42417 2.57571C8.18985 2.3414 7.80995 2.3414 7.57564 2.57571L4.57564 5.57571C4.34132 5.81003 4.34132 6.18993 4.57564 6.42424C4.80995 6.65855 5.18985 6.65855 5.42417 6.42424L7.3999 4.4485V13C7.3999 13.3313 7.66853 13.6 7.9999 13.6Z"
        fill="#4A4A5C"
    />
);

const Down = () => (
    <TransformGroup rotation="reverse">
        <Up />
    </TransformGroup>
);

const UpSecondary = () => (
    <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.9999 13.6C8.33127 13.6 8.5999 13.3313 8.5999 13V4.4485L10.5756 6.42424C10.81 6.65855 11.1899 6.65855 11.4242 6.42424C11.6585 6.18993 11.6585 5.81003 11.4242 5.57571L8.42417 2.57571C8.18985 2.3414 7.80995 2.3414 7.57564 2.57571L4.57564 5.57571C4.34132 5.81003 4.34132 6.18993 4.57564 6.42424C4.80995 6.65855 5.18985 6.65855 5.42417 6.42424L7.3999 4.4485V13C7.3999 13.3313 7.66853 13.6 7.9999 13.6Z"
        fill="#C5C2CD"
    />
);

const DownSecondary = () => (
    <TransformGroup rotation="reverse">
        <UpSecondary />
    </TransformGroup>
);

const UpDown = () => (
    <>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.5756 13.4242C10.81 13.6586 11.1899 13.6586 11.4242 13.4242L14.4242 10.4242C14.6585 10.1899 14.6585 9.81003 14.4242 9.57571C14.1899 9.3414 13.81 9.3414 13.5756 9.57571L11.5999 11.5514V2.99998C11.5999 2.6686 11.3313 2.39997 10.9999 2.39997C10.6685 2.39997 10.3999 2.6686 10.3999 2.99998V11.5514L8.42417 9.57571C8.18985 9.3414 7.80995 9.3414 7.57564 9.57571C7.34132 9.81003 7.34132 10.1899 7.57564 10.4242L10.5756 13.4242Z"
            fill="#C5C2CD"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.0001 13.6C4.66873 13.6 4.4001 13.3313 4.4001 13V4.4485L2.42436 6.42424C2.19005 6.65855 1.81015 6.65855 1.57583 6.42424C1.34152 6.18993 1.34152 5.81003 1.57583 5.57571L4.57583 2.57571C4.81015 2.3414 5.19005 2.3414 5.42436 2.57571L8.42436 5.57571C8.65868 5.81003 8.65868 6.18993 8.42436 6.42424C8.19005 6.65855 7.81015 6.65855 7.57583 6.42424L5.6001 4.4485V13C5.6001 13.3313 5.33147 13.6 5.0001 13.6Z"
            fill="#4A4A5C"
        />
    </>
);

const UpUp = () => (
    <>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.0756 2.57576C10.31 2.34145 10.6899 2.34145 10.9242 2.57576L13.9242 5.57576C14.1585 5.81008 14.1585 6.18997 13.9242 6.42429C13.6899 6.6586 13.31 6.6586 13.0756 6.42429L11.0999 4.44855V13C11.0999 13.3314 10.8313 13.6 10.4999 13.6C10.1685 13.6 9.8999 13.3314 9.8999 13V4.44855L7.92417 6.42429C7.68985 6.6586 7.30995 6.6586 7.07564 6.42429C6.84132 6.18997 6.84132 5.81008 7.07564 5.57576L10.0756 2.57576Z"
            fill="#C5C2CD"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.5001 13.6C5.16873 13.6 4.9001 13.3313 4.9001 13V4.4485L2.92436 6.42424C2.69005 6.65855 2.31015 6.65855 2.07583 6.42424C1.84152 6.18993 1.84152 5.81003 2.07583 5.57571L5.07583 2.57571C5.31015 2.3414 5.69005 2.3414 5.92436 2.57571L8.92436 5.57571C9.15868 5.81003 9.15868 6.18993 8.92436 6.42424C8.69005 6.65855 8.31015 6.65855 8.07583 6.42424L6.1001 4.4485V13C6.1001 13.3313 5.83147 13.6 5.5001 13.6Z"
            fill="#4A4A5C"
        />
    </>
);

const DownDown = () => (
    <>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.0756 13.4242C10.31 13.6586 10.6899 13.6586 10.9242 13.4242L13.9242 10.4242C14.1585 10.1899 14.1585 9.81003 13.9242 9.57571C13.6899 9.3414 13.31 9.3414 13.0756 9.57571L11.0999 11.5514V2.99998C11.0999 2.6686 10.8313 2.39997 10.4999 2.39997C10.1685 2.39997 9.8999 2.6686 9.8999 2.99998V11.5514L7.92417 9.57571C7.68985 9.3414 7.30995 9.3414 7.07564 9.57571C6.84132 9.81003 6.84132 10.1899 7.07564 10.4242L10.0756 13.4242Z"
            fill="#C5C2CD"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.5001 2.40002C5.16873 2.40002 4.9001 2.66865 4.9001 3.00002V11.5515L2.92436 9.57576C2.69005 9.34145 2.31015 9.34145 2.07583 9.57576C1.84152 9.81007 1.84152 10.19 2.07583 10.4243L5.07583 13.4243C5.31015 13.6586 5.69005 13.6586 5.92436 13.4243L8.92436 10.4243C9.15868 10.19 9.15868 9.81007 8.92436 9.57576C8.69005 9.34145 8.31015 9.34145 8.07583 9.57576L6.1001 11.5515V3.00002C6.1001 2.66865 5.83147 2.40002 5.5001 2.40002Z"
            fill="#4A4A5C"
        />
    </>
);

const DownUp = () => (
    <>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.5756 2.57576C10.81 2.34145 11.1899 2.34145 11.4242 2.57576L14.4242 5.57576C14.6585 5.81008 14.6585 6.18997 14.4242 6.42429C14.1899 6.6586 13.81 6.6586 13.5756 6.42429L11.5999 4.44855V13C11.5999 13.3314 11.3313 13.6 10.9999 13.6C10.6685 13.6 10.3999 13.3314 10.3999 13V4.44855L8.42417 6.42429C8.18985 6.6586 7.80995 6.6586 7.57564 6.42429C7.34132 6.18997 7.34132 5.81008 7.57564 5.57576L10.5756 2.57576Z"
            fill="#C5C2CD"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.0001 2.40002C4.66873 2.40002 4.4001 2.66865 4.4001 3.00002V11.5515L2.42436 9.57576C2.19005 9.34145 1.81015 9.34145 1.57583 9.57576C1.34152 9.81007 1.34152 10.19 1.57583 10.4243L4.57583 13.4243C4.81015 13.6586 5.19005 13.6586 5.42436 13.4243L8.42436 10.4243C8.65868 10.19 8.65868 9.81007 8.42436 9.57576C8.19005 9.34145 7.81015 9.34145 7.57583 9.57576L5.6001 11.5515V3.00002C5.6001 2.66865 5.33147 2.40002 5.0001 2.40002Z"
            fill="#4A4A5C"
        />
    </>
);

export const Sorting = {
    Default,
    Up,
    Down,
    UpSecondary,
    DownSecondary,
    UpDown,
    UpUp,
    DownDown,
    DownUp,
};
